import { Box, styled } from '@mui/joy';

import { LEFT_MENU_WIDTH } from 'theme/constants';

export const Wrapper = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  minHeight: '100vh',
  width: LEFT_MENU_WIDTH,
  padding: '18px 0px',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 25,
  borderRight: `1px solid ${theme.palette.neutral.outlinedBorder}`,
  background: theme.palette.background.surface,
}));

export const LogoWrapper = styled(Box)({
  display: 'flex',
  width: LEFT_MENU_WIDTH,
  flexDirection: 'column',
  alignItems: 'center',
});

export const MenuItemWrapper = styled(Box)({});
